import { useState } from "react";
import { useDispatch } from "react-redux";
import { passwordRegex } from "../../utils/regex/formRegexConstant";
import { _vendorAdminRoutes } from "../../utils/appRouter";

const SetPassword = ({ formik, setSideBarState, handleSubmit }) => {
  const [hideShowPass, setHideShowPass] = useState(true);
  const [hideShowConfrmPass, setHideShowConfrmPass] = useState(true);
  const [passwordStrength, setPasswordStrength] = useState("");
  const { touched, errors, values, setFieldValue, setFieldError } = formik;

  // ✅ Handle password typing
  const handlePasswordChange = (e) => {
    const password = e.target.value;
    setFieldValue("password", password);

    // Password strength logic
    if (password.length < 6) {
      setPasswordStrength("Weak");
    } else if (password.length < 8) {
      setPasswordStrength("Medium");
    } else if (passwordRegex.test(password)) {
      setPasswordStrength("Strong");
    } else {
      setPasswordStrength("Medium");
    }

    // Formik validation
    if (!passwordRegex.test(password)) {
      setFieldError(
        "password",
        "Use a password with 8+ characters, 1 letter, 1 number, and 1 special character"
      );
    }
  };

  const handleBack = () => {
    setSideBarState((prevState) => ({
      aboutCompany: { isCompleted: true, isActive: false },
      aboutYou: { isCompleted: true, isActive: true },
      setPassword: { isCompleted: false, isActive: false },
      mobileOtp: { isCompleted: false, isActive: false },
      emailOtp: { isCompleted: false, isActive: false },
    }));
  };

  return (
    <div className="col-md-8 px-5">
      <div className="row mt-5 px-5">
        <div className="col-md-12">
          <div className="about-section">
            <h4>Set a password</h4>
            <p>Signup - company</p>
          </div>
        </div>

        {/* Password */}
        <div className="col-md-12 mt-3">
          <label className="label-input mb-1">Your Password</label> <br />
          <div className="position-relative">
            <input
              type={hideShowPass ? "password" : "text"}
              className="form-control login-input"
              placeholder="Enter password"
              value={values.password}
              onChange={handlePasswordChange} // ✅ update password & check strength
              onBlur={formik.handleBlur}
            />
            {hideShowPass ? (
              <img
                style={{ cursor: "pointer" }}
                onClick={() => setHideShowPass(false)}
                src="/images/close-eyesinput.svg"
                className="input-icons"
                alt="/"
              />
            ) : (
              <img
                style={{ cursor: "pointer" }}
                onClick={() => setHideShowPass(true)}
                src="/images/open-eyesinput.svg"
                className="input-icons"
                alt="/"
              />
            )}
            {touched?.password && errors?.password && (
              <span style={{ fontSize: "14px", color: "red" }}>
                {errors.password}
              </span>
            )}
          </div>
        </div>

        {/* Password Strength Indicator */}
        <div className="col-md-12 mt-3">
          <label className="label-input mb-1">Strength:</label> <br />
          <div className="step-indicator d-flex">
            <div
              className={`step-bar ${passwordStrength === "Weak" ||
                passwordStrength === "Medium" ||
                passwordStrength === "Strong"
                ? "active"
                : ""
                }`}
            ></div>
            <div
              className={`step-bar ${passwordStrength === "Medium" || passwordStrength === "Strong"
                ? "active"
                : ""
                }`}
            ></div>
            <div
              className={`step-bar ${passwordStrength === "Strong" ? "active" : ""
                }`}
            ></div>
          </div>
          <small
            style={{
              color:
                passwordStrength === "Strong"
                  ? "green"
                  : passwordStrength === "Medium"
                    ? "orange"
                    : "red",
            }}
          >
            {passwordStrength}
          </small>
        </div>

        {/* Confirm Password */}
        <div className="col-md-12 mt-3">
          <label className="label-input mb-1">Confirm Password</label> <br />
          <div className="position-relative">
            <input
              type={hideShowConfrmPass ? "password" : "text"}
              className="form-control login-input"
              placeholder="Confirm password"
              value={values.confirmPassword || ""}
              onChange={(e) => setFieldValue("confirmPassword", e.target.value)}
            />
            {hideShowConfrmPass ? (
              <img
                style={{ cursor: "pointer" }}
                onClick={() => setHideShowConfrmPass(false)}
                src="/images/close-eyesinput.svg"
                className="input-icons"
                alt="/"
              />
            ) : (
              <img
                style={{ cursor: "pointer" }}
                onClick={() => setHideShowConfrmPass(true)}
                src="/images/open-eyesinput.svg"
                className="input-icons"
                alt="/"
              />
            )}
            {touched.confirmPassword && errors.confirmPassword && (
              <div className="text-red-500 text-sm">{errors.confirmPassword}</div>
            )}
          </div>
        </div>

        {/* Buttons */}
        <div className="col-md-6 mb-5 mt-5 pt-5">
          <button
            type="button"
            className="btn btn-dark back-btn"
            onClick={handleBack}
          >
            Back
          </button>
        </div>

        <div className="col-md-6 mb-5 mt-5 pt-5">
          <button type="button" className="btn btn-dark login-btn" onClick={handleSubmit}>
            Finish
          </button>
        </div>

        <div className="col-md-12 pb-4">
          <p className="text-center foot-text">
            Existing user?{" "}
            <a href={_vendorAdminRoutes.login} style={{ textDecoration: "underline" }}>
              Sign In
            </a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SetPassword;
